/** Where a challan's editor lives: REQUEST → its request's DC editor; quote/order DC → its order; RETURN / unlinked → opened inline here. */
export const dcTarget = (r) => {
  if (r.origin === "REQUEST") return r.request_id ? `/requests?open=${encodeURIComponent(r.request_id)}&dc=${encodeURIComponent(r.id)}` : null;
  if (r.origin === "RETURN") return null;
  return r.order_id ? `/commercial/one-orders?open=${encodeURIComponent(r.order_id)}&dc=${encodeURIComponent(r.id)}` : null;
};

export const missingLinkMessage = (r) => (r.origin === "RETURN" ? null : r.origin === "REQUEST" ? "This challan's request link is missing — opened here instead" : "This challan isn't linked to an order — opened here instead");

export const phaseChip = (phase) => (phase === "FINAL" ? ["Final", "bg-emerald-100 text-emerald-800"] : phase === "CANCELLED" ? ["Cancelled", "bg-slate-200 text-slate-600"] : ["Draft · not final", "bg-amber-100 text-amber-900"]);
